export { LogFrequencyRequirementsTab } from './LogFrequencyRequirementsTab';
